import { useContext } from "react";
import { Table, Tag } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

import useCityInvoices from "./useCityInvoices";
import PageHeader from "../../components/PageHeader";
import ModalInvoiceDetails from "./components/ModalInvoiceDetails";
import ActiveFiltersBar from "../../components/ActiveFiltersBar";
import TableCard from "../../components/TableCard";
import TableDicaHint from "../../components/TableDicaHint";
import TablePagination from "../../components/TablePagination";
import { ThemeContext } from "../../contexts/ThemeContext";
import { poeValorComPontosEmMil } from "../../utils/Conversores";

export default function CityPendingInvoices() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const {
        columns,
        isLoading,
        tableData,
        totalInvoices,
        showModalInvoice,
        handleShowModalInvoice,
        invoiceSelected,
        setInvoiceSelected,
        tableParams,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        activeFilterItems,
    } = useCityInvoices();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <PageHeader
                icon={<ClockCircleOutlined />}
                title="Notas Pendentes"
                tag={<Tag color="blue">{poeValorComPontosEmMil(totalInvoices || 0)} pendentes</Tag>}
                subtitle="Gerencie, visualize e acompanhe todas as notas fiscais pendentes de validação no sistema municipal"
            />

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique na linha ou no botão de visualização para inspecionar os dados completos da nota fiscal pendente." />

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalInvoices || 0}
                itemName="notas pendentes"
                pageSizeOptions={["10", "25", "50", "100", "200"]}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 1200 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            setInvoiceSelected(record);
                            handleShowModalInvoice();
                        },
                        style: {
                            cursor: "pointer",
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalInvoices || 0}
                itemName="notas pendentes"
                pageSizeOptions={["10", "25", "50", "100", "200"]}
                onChange={handlePaginationChange}
            />

            <ModalInvoiceDetails
                open={showModalInvoice}
                onClose={handleShowModalInvoice}
                invoice={invoiceSelected}
            />
        </div>
    );
}
